module.exports = ms =>
  new Promise(
    res =>
      setTimeout(res, ms)
  )
